import { render, staticRenderFns } from "./addExperiment .vue?vue&type=template&id=11e96cbc&scoped=true&"
import script from "./addExperiment .vue?vue&type=script&lang=js&"
export * from "./addExperiment .vue?vue&type=script&lang=js&"
import style0 from "./addExperiment .vue?vue&type=style&index=0&id=11e96cbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e96cbc",
  null
  
)

export default component.exports